import { AnalyticsMeal, AnalyticsMealType, ProductFindingMethod } from '../platforms/adobe-analytics/models';

export class AddToBagEvent {
  name = 'AddToBagEvent';

  constructor(
    public readonly meal: AnalyticsMeal,
    public readonly mealType: AnalyticsMealType,
    public readonly productFindingMethod?: ProductFindingMethod,
    public readonly isPceAddToBag?: boolean) {}
}
